import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _6kIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"6k"} ref={ref}/>
});

_6kIcon.displayName = "_6kIcon";
